import { swRequest } from "@sourcewhale/core";

export const getDemoLink = async (body) =>
  swRequest({
    path: "/api/requests/get_demo_link",
    method: "POST",
    body,
  });
